import { Outlet } from 'react-router-dom';

import { Drawer } from '../../shared/drawer';

export const MainCommercial = () => (
    <Drawer>
        <Outlet />
    </Drawer>
);
